import { gql } from '@apollo/client';

export const GET_JOB_HEADER_DATA = gql`
  query getJobForSwiper($jobId: String) {
    job(jobId: $jobId) {
      id
      title
      company
      pinned
      client {
        id
      }
      location {
        id
        name
        city
        country
        address
      }
      externalRef {
        externalId
        source
      }
      threshold
      integration {
        teamtailor {
          jobId
          companyId
        }
      }
      applications {
        totalCount
      }
      collaborators {
        users {
          user {
            id
            firstName
            lastName
            email
            flag
            client {
              orgName
            }
          }
        }
        accessGroups {
          accessGroup {
            id
            name
            description
            members {
              id
              firstName
              lastName
              flag
              email
            }
            jobs {
              job {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

export const PIN_JOB = gql`
  mutation pinJob($jobId: String!) {
    pinJob(jobId: $jobId) {
      id
      pinnedJobs {
        id
        title
        pinned
        location {
          name
        }
      }
    }
  }
`;

export const UNPIN_JOB = gql`
  mutation unpinJob($jobId: String!) {
    unpinJob(jobId: $jobId) {
      id
      pinnedJobs {
        id
        title
        pinned
        location {
          name
        }
      }
    }
  }
`;
